import React from 'react';
import { useFormContext } from 'react-hook-form';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import * as styled from './styled/NumberInput.styled';

type NumberValues = string | number | null | undefined;

export const NumberInput: React.FC<{
    disabled?: boolean;
    name: string;
    decimals?: number;
    prefix?: string;
}> = ({ disabled = false, name, decimals = 0, prefix }) => {
    const { register, setValue, watch } = useFormContext();
    const watchValue = watch(name);

    /**
     * Gets a formated value for input.  DB save needs to pass 0 for empty values but UI should show empty string
     * @param val - value to format
     * @param useZero - if true, returns 0 if val is empty, otherwise returns empty string
     * @returns
     */
    const getValue = (val: NumberValues, useZero = true): NumberValues => {
        const zeroReturn = useZero ? 0 : '';
        if (!val || val === '') return zeroReturn;
        return val;
    };

    const setLogic = (x: NumberValues, shouldValidate = false) => {
        const options = { shouldValidate };
        const value = getValue(x);
        setValue(name, value, options);
    };

    const onValueChange = (v: NumberFormatValues) => {
        setLogic(v.floatValue);
    };
    const methods = register(name);
    return (
        <>
            <NumberFormat
                prefix={prefix}
                customInput={styled.NumberInput}
                thousandSeparator={true}
                onValueChange={onValueChange}
                decimalScale={decimals}
                fixedDecimalScale={true}
                allowNegative={false}
                disabled={disabled}
                id={name}
                {...methods}
                value={getValue(watchValue, false)}
            />
        </>
    );
};
